import styled, { css } from 'styled-components';
import { Color } from 'src/utils/theme';

export const ModalContent = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    color: ${theme.co.secondary20};

    margin: ${theme.sz.s12};
    gap: ${theme.sz.s3};

    @media (max-width: ${theme.sz.md}) {
      margin: ${theme.sz.s6};
      gap: ${theme.sz.s2};
    }
  `,
);

export const CardsWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-self: stretch;

    gap: ${theme.sz.s3};
    margin-top: ${theme.sz.s3};
    margin-bottom: ${theme.sz.s3};

    @media (max-width: ${theme.sz.md}) {
      gap: ${theme.sz.s2};
      margin-top: ${theme.sz.s1};
      margin-bottom: ${theme.sz.s2};
    }
  `,
);

export const Description = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.l};

    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.paragraph.m};
    }
  `,
);

export const ModalHeader = styled.div(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.m};

    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.heading.mobile.s};
    }
  `,
);

export const Card = styled.div<{ $backgroundColor: Color }>(
  ({ theme, $backgroundColor }) => css`
    display: flex;
    gap: ${theme.sz.s1};
    padding: ${theme.sz.s6};
    border-radius: ${theme.bo.mediumSmall};
    background-color: ${theme.co[$backgroundColor]};
    align-items: baseline;

    @media (max-width: ${theme.sz.md}) {
      padding: ${theme.sz.s4} ${theme.sz.s2};
    }
  `,
);

export const IconColumn = styled.div<{ $iconColor: Color }>(
  ({ theme, $iconColor }) => css`
    font-size: ${theme.sz.s6};
    color: ${theme.co[$iconColor]};

    @media (max-width: ${theme.sz.md}) {
      font-size: ${theme.sz.s5};
    }
  `,
);

export const TextColumn = styled.div(
  () => css`
    text-align: start;
  `,
);

export const CardTitle = styled.div(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.xs};

    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.heading.mobile.xxs};
    }
  `,
);

export const CardDescription = styled.div(
  ({ theme }) => css`
    color: ${theme.co.secondary50};
    margin-top: ${theme.sz.s1};
    ${theme.typography.paragraph.base};

    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.paragraph.m};
    }
  `,
);

export const ProgressIndicator = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.base};
    color: ${theme.co.secondary50};
    margin-top: ${theme.sz.s1};

    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.paragraph.m};
    }
  `,
);

export const ActionButton = styled.div(
  () => css`
    width: 100%;
  `,
);
